module.exports = "Remove your `some` directory, including the `stuff` directory and all of its contents. This action should leave your root directory empty.\n"